// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,
  ScoreCard,GameTypeTab,StatsGraph
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';

class PartnerBFC extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  state = {
    customer_graph_tabs: [
      {name: 'Data', tablink: '1', isActive: true},    
      {name: 'Customers Trend', tablink: '2', isActive: false},
    ],
    revenue_graph_tabs: [
      {name: 'Data', tablink: '3', isActive: true},    
      {name: 'Revenue Trend', tablink: '4', isActive: false},
    ]    
  };   

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerDashboard');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
        fetchScoreCardDataIfNeeded,
      }
    } = this.props;
    $('.customer-trend').find("a").trigger("click");
    $('.revenue-trend').find("a").trigger("click");
  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerDashboard');
  }

  render() {
    const {
      statsTable,
      scoreCard,
      statsGraph,
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;

    return(
      <div>
        <div className="row">
          <ScoreCard name="dashboard_score_card_bfc" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
        </div>
        
       

       <div className="row">
          <StatsTable bigTable={true} name="active_custombers_by_venue_by_program_bfc" displayName="Active Customers this Month" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>

        </div>        

      </div>
    );
  }
}

export default PartnerBFC;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerBFC/PartnerBFC.js